import React, {useCallback, useContext, useEffect, useState} from 'react'
import classNames from 'classnames'
import _ from 'lodash'
import {Image, Input} from 'antd'
import {RiSearchLine} from 'react-icons/ri'
import {FaFilter} from 'react-icons/fa6'
import {BiSolidChurch} from 'react-icons/bi'
import {BsBookmarkHeart, BsSearch} from 'react-icons/bs'
import {HiOutlineSquares2X2, HiPlus} from 'react-icons/hi2'
import {Link} from 'react-router-dom'
import useTranslate from 'modules/local/useTranslate'
import {useDirectoryItemCrud} from '../functions/useDirectoryItemCrud'
import {useHistory} from 'modules/navigation/useRouter'
import {getRouteSearchParams, useRouteSearchParam} from 'envs/_current/history'
import {LayoutContext} from '../../../../components/layouts/Default/LayoutContext'
import usePaginationHelper, {createPagerKey} from '../../hooks/usePaginationHelper'
import {NoneStickyMeta} from '../../EntityList'
import {getResponseItem, getResponseItems, NullAsDefault} from 'views/Shared'
import {
    diocese_getDirectoryStats_Api,
    getArchdiocesesHighlighted_Api,
    religiousOrder_getReligiousOrderRecommendInfo_Api,
    search_loadFilterData_Api,
    user_fetchUserOrganizations_Api,
} from 'apis'
import useAsync from 'modules/asyncCache/useAsync'
import {LoginContext} from '../../../../components/LoginContext'
import {DirectoryTypeKeys, directoryTypes, getDirectoryTypeByKey} from '../consts/directoryTypes'
import {renderDirectoryAllCard, renderDirectoryCard, renderMyOrganizationCard} from '../functions/renderDirectoryCard'
import PageViewStatsBadge from '../../../../components/PageViewStatsBadge'
import {addFavorite, getFavorites, getStoredDefaultCountryId} from '../../../../helpers/localStorage'
import MyPastorsAndTheCatholicChurch from '../../../DiscoveryGroupExplorer/components/MyPastorsAndTheCatholicChurch'
import DirectoryDetailModal from '../components/DirectoryDetailModal'
import {PhotoPlaceholderApp} from '../../../../conts/imageBase64'
import getLinkToDetail from '../../../../helpers/getLinkToDetail'
import getTitle from "../../../../helpers/getTitle";

// Lưu "gần đây" theo từng type riêng (1 key localStorage / type) thay vì 1 mảng chung —
// để tab "Của tôi" hiển thị được gần đây theo từng loại thay vì bị 1 loại lấn hết chỗ.
const recentStorageKey = (typeKey) => 'directory_' + typeKey

const recordRecentDirectoryItem = (typeKey, item) => {
    if (!typeKey || !item) return
    addFavorite(recentStorageKey(typeKey), {
        _type: item?._type,
        id: item?.id,
        idname: item?.idname || item?.id,
        name: item?.name || item?.title || item?.organization_name,
        avatar: item?.avatar || item?.photo,
    })
}

// total_priests tính từ position_title tự do trên bảng Profile chung (không phải danh bạ giáo sĩ
// thật) nên chưa đủ tin cậy để show số - dùng chung fallback "chưa có thống kê" cho stat null/0,
// và ép luôn priests qua fallback bất kể giá trị (xem StatValue).
const formatStatValue = (value, t) => (value ? value.toLocaleString('vi-VN') : t('no stats yet'))

const TABS = {SEARCH: 'search', INTRO: 'intro', MINE: 'mine'}

// Tra cứu = tab 1 (thao tác chính người dùng cần ngay); Danh bạ (duyệt theo danh mục +
// highlight) = tab 2/giữa, mặc định khi vào trang; Của tôi = tab 3.
const TAB_ITEMS = [
    {key: TABS.SEARCH, icon: BsSearch, label: 'directory search'},
    {key: TABS.INTRO, icon: HiOutlineSquares2X2, label: 'directory catalog'},
    {key: TABS.MINE, icon: BsBookmarkHeart, label: 'my directory'},
]

const TabBar = ({tab, setTab}) => {
    const t = useTranslate()
    return (
        <div
            style={{background: 'rgba(194, 65, 12, 0.08)'}}
            className="m-1 md:m-2 p-1 rounded-2xl flex items-center gap-3 transition-all duration-300">
            {TAB_ITEMS.map((item) => {
                const Icon = item.icon
                return (
                    <button
                        type="button"
                        key={item.key}
                        onClick={() => setTab(item.key)}
                        style={{padding: '0.375rem 0.5rem', cursor: 'pointer'}}
                        className={classNames(
                            'flex-1 flex flex-col items-center gap-0.5 font-semibold rounded-xl transition-all duration-300',
                            tab === item.key ? 'bg-orange-700 text-white' : 'bg-transparent hover:opacity-80 text-orange-800'
                        )}>
                        <Icon size={15}/>
                        <span className="text-center tracking-wider leading-tight text-xs md:text-sm lg:text-base">
                            {t(item.label)}
                        </span>
                    </button>
                )
            })}
        </div>
    )
}

// mirror MassTimesPageViewStats/HymnsPageViewStats — số cột theo số entry có dữ liệu
const DirectoryPageViewStats = ({stats}) => {
    const t = useTranslate()
    const entries = [
        {key: 'total_views', label: t('total page views'), value: _.get(stats, 'total_views')},
        {key: 'unique_visitors', label: t('unique visitors'), value: _.get(stats, 'unique_visitors')},
    ].filter((e) => e.value != null)

    if (!entries.length) return null

    return (
        // Nền header giờ nhạt (giống Mass Times) — khối stats trở lại làm lớp gradient đậm
        // nổi bật, card con trắng, khớp đúng pattern MassTimesPageViewStats/HymnsPageViewStats.
        <div
            style={{background: 'linear-gradient(135deg, #9a3412 0%, #c2410c 100%)'}}
            className="p-2 rounded-xl shadow-sm">
            <div className="grid gap-2" style={{gridTemplateColumns: `repeat(${entries.length}, 1fr)`}}>
                {entries.map((entry) => (
                    <div key={entry.key} className="px-4 py-2 text-center background rounded-lg min-w-0">
                        <p className="mb-1 font-semibold text-2xs text-gray-500 uppercase tracking-wide truncate">
                            {entry.label}
                        </p>
                        <p className="text-xl font-bold leading-none text-orange-700">
                            {entry.value}
                        </p>
                    </div>
                ))}
            </div>
            <p className="mt-1.5 text-center text-2xs text-white text-opacity-80 tracking-wider">
                ({t('admin only')})
            </p>
        </div>
    )
}

const DiscoveryHeader = () => {
    const t = useTranslate()
    return (
        <div
            style={{background: 'linear-gradient(135deg, #fff7ed 0%, #fed7aa 100%)'}}
            className="border-b border-color-100">
            <div className="max-w-2xl mx-auto px-4 py-4 flex items-center gap-3">
                <div
                    style={{width: 56, height: 56}}
                    className="flex flex-center flex-shrink-0 rounded-2xl bg-orange-700 shadow-sm">
                    <BiSolidChurch size={28} className="text-white"/>
                </div>
                <div className="flex flex-col flex-1 min-w-0">
                    <span className="font-bold text-xl lg:text-2xl text-color-000 tracking-wide leading-tight">
                        Kristo Directory
                    </span>
                    <span className="text-xs font-semibold text-color-200 tracking-wide leading-snug">
                        {t('directory subtitle')}
                    </span>
                </div>
            </div>
            <div className="max-w-2xl mx-auto px-4 pb-3">
                <PageViewStatsBadge
                    type="directory"
                    render={(stats) => <DirectoryPageViewStats stats={stats}/>}
                />
            </div>
        </div>
    )
}

const TypePillRow = ({activeKey, onSelect}) => {
    const t = useTranslate()
    const pills = [{key: DirectoryTypeKeys.ALL, label: 'all', icon: null, colorClass: null}, ...directoryTypes]
    return (
        <div className="flex items-center gap-2 overflow-x-auto px-3 py-2" style={{scrollbarWidth: 'none'}}>
            {pills.map((pill) => {
                const active = activeKey === pill.key
                const Icon = pill.icon
                return (
                    <button
                        type="button"
                        key={pill.key}
                        onClick={() => onSelect(pill.key)}
                        style={{minHeight: 32}}
                        className={classNames(
                            'flex-shrink-0 flex items-center gap-1.5 px-3 rounded-lg text-xs font-semibold transition-all cursor-pointer whitespace-no-wrap',
                            active
                                ? 'bg-orange-700 text-white'
                                : 'bg-slate-50 text-slate-500 border border-slate-200 hover:border-orange-700 hover:text-orange-800'
                        )}>
                        {Icon && <Icon size={13} className={active ? 'text-white' : pill.colorClass}/>}
                        {t(pill.label)}
                    </button>
                )
            })}
        </div>
    )
}

const DirectorySearchResults = ({activeTypeKey, onSelectItem}) => {
    const t = useTranslate()
    const history = useHistory()
    const [localKeyword, setLocalKeyword] = useState('')
    const [showFilter, setShowFilter] = useState(false)
    const [filterState, setFilterState] = useState({})

    const activeType = activeTypeKey === DirectoryTypeKeys.ALL ? null : getDirectoryTypeByKey(activeTypeKey)
    const keywordParam = useRouteSearchParam('keyword')
    const hasSearched = !!keywordParam || !_.isEmpty(filterState)

    const submitKeyword = useCallback(
        (value) => {
            let search_params = getRouteSearchParams()
            if (value) {
                search_params.set('keyword', value)
            } else {
                search_params.delete('keyword')
            }
            history.push({search: '?' + search_params.toString()})
        },
        [history]
    )

    useEffect(() => {
        setLocalKeyword(keywordParam ?? '')
    }, [keywordParam])

    const handleSelectItem = useCallback((item) => {
        const resolvedTypeKey = activeTypeKey === DirectoryTypeKeys.ALL
            ? directoryTypes.find((e) => e.owner_type === item?._type)?.key
            : activeTypeKey
        onSelectItem(item, resolvedTypeKey)
    }, [activeTypeKey, onSelectItem])

    const allApiInfo = {
        ...search_loadFilterData_Api,
        path: search_loadFilterData_Api.path.replace(':type', 'directory'),
    }

    // Thêm/sửa/xóa ngay tại tab Tra cứu - generic cho mọi loại có khai báo `crud` trong
    // directoryTypes.js (hiện: Giáo xứ, Nhân vật), không hardcode riêng loại nào ở đây.
    const {refreshKey, renderContextMenu, createButton, modal} = useDirectoryItemCrud(activeType?.crud)

    const [pager_widget] = usePaginationHelper({
        sortHeader: null,
        SortByWidget: NullAsDefault,
        AdvancedFilter: NullAsDefault,
        renderFilter: NullAsDefault,
        query_params: {keyword: 'keyword'},
        withKey: createPagerKey([activeTypeKey, JSON.stringify(filterState), refreshKey]),
        pagerInfo: {
            RenderEntity: React.Fragment,
            PaginationMeta: NoneStickyMeta,
            apiInfo: activeType ? activeType.apiInfo : allApiInfo,
            renderItem: activeType
                ? renderDirectoryCard({
                    typeConfig: activeType,
                    translate: t,
                    onSelect: handleSelectItem,
                    renderContextMenu,
                })
                : renderDirectoryAllCard({translate: t, onSelect: handleSelectItem}),
            renderWrap: (child) => <div className="flex flex-col gap-2 px-3 pb-4">{child}</div>,
        },
        // Thứ tự merge: defaultFilterValues (mặc định tab, user ghi đè được) -> values (user chọn) ->
        // fixedValues (bất biến, luôn thắng). Không gộp default vào filterState/React state để
        // hasSearched (dựa trên !_.isEmpty(filterState)) không bị coi là "đã search" khi user chưa
        // thao tác gì.
        withValues: (values) => ({
            ...(activeType?.defaultFilterValues ?? {}),
            ...values,
            ...(activeType?.fixedValues ?? {}),
        }),
        onInit: ({onFilterChange}) => onFilterChange(filterState),
        dependencies: [JSON.stringify(filterState), activeTypeKey, refreshKey],
        noHeader: true,
        renderHeader: NullAsDefault,
    })

    const FilterComponent = activeType?.FilterComponent
    const guide = activeType?.guide

    return (
        <div className="flex flex-col gap-3">
            <div className="flex flex-col gap-3 px-3">
                {guide && (
                    <div className="flex items-start gap-3 p-3 bg-blue-50 border border-blue-100 rounded-xl">
                        <RiSearchLine size={18} className="text-blue-500 flex-shrink-0 mt-0.5"/>
                        <div className="flex-1 min-w-0 flex flex-col gap-0.5">
                            <span className="font-semibold text-sm text-color-000">{t(guide.title)}</span>
                            <span className="text-xs text-color-400">{t(guide.description)}</span>
                        </div>
                        <Link
                            to={guide.createTo}
                            className="flex-shrink-0 flex items-center gap-1 px-2.5 py-1.5 rounded-lg text-xs font-semibold no-underline bg-blue-600 hover:bg-blue-700 text-white transition-all">
                            <HiPlus size={14}/>
                            {t(guide.createLabel)}
                        </Link>
                    </div>
                )}
                <div className="flex items-center gap-2">
                    <Input
                        value={localKeyword}
                        onChange={(e) => setLocalKeyword(e.target.value)}
                        onPressEnter={() => submitKeyword(localKeyword)}
                        onBlur={() => submitKeyword(localKeyword)}
                        allowClear
                        onClear={() => submitKeyword('')}
                        size="large"
                        prefix={<RiSearchLine size={14} className="text-color-400"/>}
                        placeholder={t('search parish, patron saint...')}
                        className="flex-1 rounded-lg"
                    />
                    {FilterComponent && (
                        <button
                            type="button"
                            onClick={() => setShowFilter((v) => !v)}
                            style={{width: 40, height: 40, borderRadius: '0.65rem', cursor: 'pointer'}}
                            className={classNames(
                                'flex flex-center transition-all border duration-300',
                                showFilter
                                    ? 'bg-orange-700 border-orange-700 text-white'
                                    : 'hover:scale-96 bg-orange-50 hover:bg-orange-100 border-orange-400 hover:border-orange-700 text-orange-700'
                            )}>
                            <FaFilter size={16}/>
                        </button>
                    )}
                    {createButton}
                </div>
                {FilterComponent && showFilter && (
                    <div className="p-3 shadow-md border border-orange-100 rounded-xl">
                        <FilterComponent value={filterState} onChange={setFilterState}/>
                    </div>
                )}
            </div>
            {hasSearched ? pager_widget : (
                <div
                    className="mx-3 p-6 flex flex-col items-center gap-2 text-center background border border-dashed border-color-100 rounded-xl">
                    <RiSearchLine size={32} className="text-color-300"/>
                    <p className="font-semibold text-sm text-color-200 m-0">
                        {t('enter keyword to search directory')}
                    </p>
                    <p className="text-xs text-color-400 max-w-xs m-0">
                        {t('search directory hint')}
                    </p>
                </div>
            )}
            {modal}
        </div>
    )
}

const CategoryGrid = ({onSelect, stats}) => {
    const t = useTranslate()
    return (
        <div className="grid grid-cols-3 gap-2">
            {directoryTypes.map((type) => {
                const Icon = type.icon
                const count = _.get(stats, type.statsKey)
                return (
                    <button
                        type="button"
                        key={type.key}
                        onClick={() => onSelect(type.key)}
                        style={{cursor: 'pointer'}}
                        className="p-3 flex flex-col items-center gap-1 background border border-color-50 shadow-sm hover:shadow-md hover:border-orange-300 rounded-xl transition-all">
                        <div
                            style={{width: 44, height: 44}}
                            className={classNames('flex flex-center flex-shrink-0 rounded-xl', type.badgeBg)}>
                            <Icon size={20} className={type.colorClass}/>
                        </div>
                        <span className="text-xs font-semibold text-color-000 text-center leading-tight">
                            {t(type.label)}
                        </span>
                        <span className="text-2xs font-semibold text-color-300 tracking-wide">
                            {formatStatValue(count, t)}
                        </span>
                    </button>
                )
            })}
        </div>
    )
}

// Block ảnh + số liệu thật (không hardcode) — copy đúng card pattern đã dùng ở
// DioceseLandingPage.js, API đã có sẵn (mặc định country_id=237, diocese_typecd=archdiocese).
const DioceseHighlightSection = ({onOpenDetail}) => {
    const t = useTranslate()
    const {response} = useAsync({apiInfo: getArchdiocesesHighlighted_Api})
    const items = Array.from(getResponseItem(response) ?? []).slice(0, 3)

    if (!items.length) return null

    return (
        <div className="flex flex-col gap-2">
            <span className="font-bold text-xs text-color-400 uppercase tracking-widest">
                {t('highlighted dioceses')}
            </span>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
                {items.map((item, i) => (
                    <div
                        key={item?.id || i}
                        onClick={() => onOpenDetail(item, DirectoryTypeKeys.DIOCESE)}
                        className="flex flex-col background border border-color-50 shadow-sm hover:shadow-md rounded-xl overflow-hidden cursor-pointer transition-all">
                        <div className="relative">
                            <Image
                                src={item?.church?.photo || PhotoPlaceholderApp}
                                fallback={PhotoPlaceholderApp}
                                preview={false}
                                wrapperClassName="w-full"
                                className="object-cover"
                                style={{height: 120}}
                            />
                            <div
                                style={{
                                    background: 'linear-gradient(to top, rgba(0,0,0,0.75), rgba(0,0,0,0))',
                                    height: 60
                                }}
                                className="w-full absolute bottom-0"/>
                            <span
                                className="p-2 font-bold text-sm text-white tracking-wide absolute bottom-0 left-0 leading-tight max-lines-2">
                                {item?.name}
                            </span>
                        </div>
                        {/* total_priests tính từ position_title tự do trên bảng Profile chung, chưa phải
                            danh bạ giáo sĩ thật - chưa bao giờ có số thật nên bỏ hẳn ô này, chỉ còn giáo xứ. */}
                        <div className="p-2 flex justify-center">
                            <div className="text-center">
                                <p className="font-bold text-sm text-color-000 m-0">
                                    {formatStatValue(item?.total_parishes, t)}
                                </p>
                                <p className="text-2xs text-color-400 uppercase tracking-wider m-0">{t('parish')}</p>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )
}

// Đảm bảo card "Dòng tu tiêu biểu" có cả dòng nam (target_gender=1) lẫn dòng nữ (target_gender=2)
// khi dữ liệu cho phép, thay vì chỉ lấy N item đầu theo alphabet (dễ lệch hẳn về 1 giới).
const pickBalancedByGender = (items, limit) => {
    const male = items.find((e) => e?.target_gender === 1)
    const female = items.find((e) => e?.target_gender === 2)
    const picked = [male, female].filter(Boolean)
    for (const item of items) {
        if (picked.length >= limit) break
        if (!picked.includes(item)) picked.push(item)
    }
    return picked.slice(0, limit)
}

// religiousOrder_getReligiousOrderRecommendInfo_Api trả chung highlighted_items cho cả
// Dòng tu lẫn Hội đoàn (khác nhau qua nature_typecd) — lọc đúng "religious_order",
// copy pattern từ ReligiousOrderSearchViewDefault.js.
const ReligiousOrderHighlightSection = ({onOpenDetail}) => {
    const t = useTranslate()
    // Random 6 dòng tu/hội đoàn tiêu biểu theo quốc gia session hiện tại (getStoredDefaultCountryId,
    // cùng convention với các trang danh bạ khác - Churches.js, Dioceses.js...), không hardcode VN.
    const country_id = getStoredDefaultCountryId()
    const {response} = useAsync({
        apiInfo: religiousOrder_getReligiousOrderRecommendInfo_Api,
        query: {country_id},
    })
    const {highlighted_items = []} = getResponseItem(response) ?? {}
    const items = pickBalancedByGender(
        highlighted_items.filter((e) => e?.nature_typecd === 'religious_order'),
        6
    )

    if (!items.length) return null

    return (
        <div className="flex flex-col gap-2">
            <span className="font-bold text-xs text-color-400 uppercase tracking-widest">
                {t('highlighted religious orders')}
            </span>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
                {items.map((item, i) => (
                    <div
                        key={item?.id || i}
                        onClick={() => onOpenDetail(item, DirectoryTypeKeys.RELIGIOUS_ORDER)}
                        className="flex flex-col background border border-color-50 shadow-sm hover:shadow-md rounded-xl overflow-hidden cursor-pointer transition-all">
                        <Image
                            src={item?.photo || PhotoPlaceholderApp}
                            fallback={PhotoPlaceholderApp}
                            preview={false}
                            wrapperClassName="w-full"
                            className="object-cover"
                            style={{height: 'auto', aspectRatio: '1 / 1'}}
                        />
                        <div className="p-2">
                            <p className="font-bold text-sm text-color-000 m-0 max-lines-2">{item?.name}</p>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )
}

const IntroTab = ({onSelectType, onOpenDetail}) => {
    const t = useTranslate()
    // Tổng số bản ghi từng loại — cache daily qua GlobalInfo (schedule:update_global_infos) + Cache::
    // remember phía backend, ít thay đổi nên không cần refetch/polling ở đây.
    const {response: statsResponse} = useAsync({apiInfo: diocese_getDirectoryStats_Api})
    const stats = getResponseItem(statsResponse)

    return (
        <div className="flex flex-col gap-10 px-3 py-4">
            <div className="flex flex-col gap-2">
                <div className="flex items-center justify-between">
                    <span className="font-bold text-xs text-color-400 uppercase tracking-widest">
                        {t('directory categories')}
                    </span>
                    <span
                        onClick={() => onSelectType(DirectoryTypeKeys.ALL)}
                        className="text-xs font-semibold text-orange-700 cursor-pointer hover:underline">
                        {t('view all')}
                    </span>
                </div>
                <CategoryGrid onSelect={onSelectType} stats={stats}/>
            </div>

            <DioceseHighlightSection onOpenDetail={onOpenDetail}/>
            <ReligiousOrderHighlightSection onOpenDetail={onOpenDetail}/>

            <MyPastorsAndTheCatholicChurch/>

            <div className="h-15"/>
        </div>
    )
}

const RecentDirectoryTypeSection = ({typeConfig, onSelectItem}) => {
    const items = getFavorites(recentStorageKey(typeConfig.key))
    if (!items?.length) return null
    const Icon = typeConfig.icon

    return (
        <div className="flex flex-col gap-2">
            <div className="flex items-center gap-1.5">
                <Icon size={13} className={typeConfig.colorClass}/>
                <span className="font-bold text-xs text-color-400 uppercase tracking-widest">
                    {typeConfig.translatedLabel}
                </span>
            </div>
            <div className="flex flex-col gap-2">
                {items.map((item, i) => (
                    <div
                        key={i}
                        onClick={() => onSelectItem(item, typeConfig.key)}
                        className="flex items-center gap-3 px-3 py-2.5 background rounded-xl border border-color-50 hover:shadow-md cursor-pointer transition-all">
                        <div
                            style={{width: 40, height: 40}}
                            className={classNames('flex flex-center flex-shrink-0 rounded-xl overflow-hidden', typeConfig.badgeBg)}>
                            {item?.avatar
                                ? <img src={item.avatar} alt={getTitle(item)} className="w-full h-full object-cover"/>
                                : <Icon size={18} className={typeConfig.colorClass}/>}
                        </div>
                        <span className="font-semibold text-sm text-color-000 truncate flex-1">
                            {getTitle(item) || item?.organization_name}
                        </span>
                    </div>
                ))}
            </div>
        </div>
    )
}

// Tổ chức mình đã tham gia (student/teacher/member/admin/following gộp — không truyền
// filter_group) — thay cho placeholder "theo dõi và đóng góp" cũ, dùng lại đúng API/route
// đã có sẵn của Organization (không có thì ẩn hẳn khối này).
const MyOrganizationsSection = ({onSelectOrganization}) => {
    const t = useTranslate()
    const login = useContext(LoginContext)
    const {response} = useAsync({
        apiInfo: user_fetchUserOrganizations_Api,
        values: {sort_by: 'date desc'},
    })
    const items = getResponseItems(response)?.slice(0, 5) ?? []

    if (!login?.id || !items.length) return null

    // Dùng chung DirectoryCardRow (qua renderMyOrganizationCard) với các tab khác - card hiện
    // badge loại (Giáo xứ/Giáo phận/Dòng tu/Hội đoàn) + giáo phận + địa chỉ nếu có, thay vì chỉ
    // avatar + tên như trước (không phân biệt được đang xem loại tổ chức gì).
    const renderCard = renderMyOrganizationCard({translate: t, onSelect: onSelectOrganization})

    return (
        <div className="flex flex-col gap-2">
            <span className="font-bold text-xs text-color-400 uppercase tracking-widest">
                {t('my organizations')}
            </span>
            <div className="flex flex-col gap-2">
                {items.map(renderCard)}
            </div>
        </div>
    )
}

const EmptyRecentState = () => {
    const t = useTranslate()
    return (
        <div
            className="mx-3 p-6 flex flex-col items-center gap-2 text-center background border border-dashed border-color-100 rounded-xl">
            <BsBookmarkHeart size={28} className="text-color-300"/>
            <p className="text-sm text-color-300 italic tracking-wider m-0">
                {t('no recently viewed directory items')}
            </p>
        </div>
    )
}

const MineTab = ({onSelectItem}) => {
    const t = useTranslate()
    const history = useHistory()
    const hasAnyRecent = directoryTypes.some((type) => getFavorites(recentStorageKey(type.key))?.length > 0)

    return (
        <div className="flex flex-col gap-10 px-3 py-4">
            <div className="flex flex-col gap-2">
                <span className="font-bold text-xs text-color-400 uppercase tracking-widest">
                    {t('directory recently viewed')}
                </span>
                {hasAnyRecent ? (
                    directoryTypes.map((type) => (
                        <RecentDirectoryTypeSection
                            key={type.key}
                            typeConfig={{...type, translatedLabel: t(type.label)}}
                            onSelectItem={onSelectItem}
                        />
                    ))
                ) : (
                    <EmptyRecentState/>
                )}
            </div>

            <MyOrganizationsSection onSelectOrganization={(item) => history.push(getLinkToDetail(item))}/>
        </div>
    )
}

const DiscoveryPage = () => {
    const {isLg} = useContext(LayoutContext)
    const history = useHistory()
    const [selectedDetail, setSelectedDetail] = useState(null)

    const tab = useRouteSearchParam('tab') ?? TABS.INTRO
    const typeKey = useRouteSearchParam('type') ?? DirectoryTypeKeys.ALL

    const openDetail = useCallback((item, itemTypeKey) => {
        // Giáo xứ đôi khi được index dưới owner_type=organization (trang Organization đầy đủ
        // đã có sẵn, không có modal riêng cho case này) — điều hướng thẳng thay vì mở modal.
        if (item?._type === 'organization') {
            history.push(getLinkToDetail(item))
            return
        }
        recordRecentDirectoryItem(itemTypeKey, item)
        setSelectedDetail({item, typeKey: itemTypeKey})
    }, [history])

    const setTab = useCallback(
        (key) => {
            const sp = getRouteSearchParams()
            sp.set('tab', key)
            history.push({search: '?' + sp.toString()})
        },
        [history]
    )

    const handleSelectType = useCallback(
        (key) => {
            history.push({search: '?' + new URLSearchParams({tab: TABS.SEARCH, type: key}).toString()})
        },
        [history]
    )

    return (
        <div className="directory-theme flex flex-col min-h-screen background-50">
            <DiscoveryHeader/>
            <div className="flex-1 w-full max-w-2xl mx-auto flex flex-col">
                <div
                    className={classNames('background-50 transition-all duration-300', isLg ? 'stickyTop1' : 'stickyTop')}>
                    <TabBar tab={tab} setTab={setTab}/>
                </div>

                {tab === TABS.INTRO && (
                    <IntroTab onSelectType={handleSelectType} onOpenDetail={openDetail}/>
                )}
                {tab === TABS.SEARCH && (
                    <React.Fragment>
                        <TypePillRow activeKey={typeKey} onSelect={handleSelectType}/>
                        <DirectorySearchResults key={typeKey} activeTypeKey={typeKey} onSelectItem={openDetail}/>
                    </React.Fragment>
                )}
                {tab === TABS.MINE && <MineTab onSelectItem={openDetail}/>}
                <div className="h-32"/>
            </div>
            <DirectoryDetailModal
                item={selectedDetail?.item}
                typeKey={selectedDetail?.typeKey}
                onClose={() => setSelectedDetail(null)}
            />
        </div>
    )
}

export default DiscoveryPage
